module.exports = __webpack_public_path__ + "static/img/008.975b343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/008.png
// module id = 1bCZ
// module chunks = 37